import { IconCross } from '@monofe/ui-common/icon';
import type { IA2HSState } from '../interface';
import InstallBannerView from './InstallBannerView';
import { classNameForElement, StyleElem, styleForElement } from './MainView.style';

function MainView(props: IA2HSState): JSX.Element {
    const style = (element: StyleElem) => styleForElement(element, props);
    const className = (element: StyleElem) => classNameForElement(element, props);

    return (
        <div className={className(StyleElem.Container)} style={style(StyleElem.Container)}>
            <InstallBannerView
                aria-live="assertive"
                className={className(StyleElem.InstallBanner)}
                style={style(StyleElem.InstallBanner)}
                {...props}
            >
                <IconCross
                    className={className(StyleElem.IconCross)}
                    style={style(StyleElem.IconCross)}
                />
            </InstallBannerView>
        </div>
    );
}

export default MainView;
